import { render } from "./ContextMenuSeparator.vue?vue&type=template&id=6dcb815f&scoped=true"
import script from "./ContextMenuSeparator.vue?vue&type=script&lang=js"
export * from "./ContextMenuSeparator.vue?vue&type=script&lang=js"

import "./ContextMenuSeparator.vue?vue&type=style&index=0&id=6dcb815f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcb815f"]])

export default __exports__